var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconmonstr-map-thin 1",
    clipPath: "url(#clip0_12331_29225)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.125 25L22.0562 30L15.125 25L8.19375 30L0.125 25V0L8.19375 5L15.125 0L22.0562 5L30.125 0V25ZM15.75 8.75H14.5V1.9925L8.875 6.05V11.25H7.625V6.1175L1.375 2.245V24.3038L7.625 28.1775V20H8.875V27.9675L14.5 23.91V17.5H15.75V23.91L21.375 27.9675V21.25H22.625V28.1775L28.875 24.3038V2.245L22.625 6.1175V10H21.375V6.05L15.75 1.9925V8.75ZM25.965 17.52L24.345 15.9275L25.9363 14.3113L25.0513 13.4338L23.4613 15.0513L21.8438 13.4625L20.965 14.34L22.585 15.935L20.9937 17.555L21.8725 18.4338L23.4688 16.8113L25.0875 18.405L25.965 17.52ZM8.3375 16.7625C7.87125 16.7625 7.41125 16.68 6.9725 16.5187L7.48125 15.1375C7.7575 15.2387 8.045 15.29 8.3375 15.29C8.6625 15.29 8.98 15.2275 9.28 15.1038L9.84 16.4663C9.36125 16.6625 8.85625 16.7625 8.3375 16.7625ZM5.08625 13.795C4.4175 13.795 3.875 14.3362 3.875 15.005C3.875 15.6725 4.4175 16.215 5.08625 16.215C5.755 16.215 6.2975 15.6725 6.2975 15.005C6.2975 14.3362 5.755 13.795 5.08625 13.795ZM19.175 15.7837L17.1012 14.6025L17.83 13.3225L19.905 14.5037L19.175 15.7837ZM11.1062 15.7588L10.35 14.495L12.3975 13.2687L13.155 14.5312L11.1062 15.7588ZM16.0037 13.9988C15.7 13.8725 15.3787 13.8075 15.05 13.8075C14.7612 13.8075 14.4787 13.8575 14.2075 13.955L13.705 12.57C14.1375 12.4137 14.59 12.335 15.05 12.335C15.5737 12.335 16.0875 12.4375 16.57 12.6388L16.0037 13.9988Z",
    fill: "url(#paint0_linear_12331_29225)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12331_29225",
    x1: 30.125,
    y1: 0,
    x2: -2.67866,
    y2: 26.5338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12331_29225"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0.125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.98088ad10e16ac609aae4cd7cb83f39a.svg";
export { ForwardRef as ReactComponent };